import { useTranslation } from "react-i18next";

const RequestStatusOptions = (list) => {
  const { t } = useTranslation();
  const options = [
    {
      key: "open",
      title: t("options.requestStatus.open"),
      value: "OPEN",
    },
    {
      key: "done",
      title: t("options.requestStatus.done"),
      value: "DONE",
    },
    {
      key: "closed",
      title: t("options.requestStatus.closed"),
      value: "CLOSED",
    },
  ];

  if (typeof list === "string" && list.toLowerCase() === "all") {
    return options;
  }
  if (Array.isArray(list)) {
    const newOptions = [];
    for (const item of list) {
      const newOption = options.find(
        (option) => item === option.value || item === option.key.toLowerCase(),
      );
      newOptions.push(newOption);
    }
    return newOptions;
  }
  return [];
};

export default RequestStatusOptions;
